import { MealsService } from '@/backend/market'
import type {
  PostCancelMealAdminRequest,
  PostScheduledMyMealProgramAdminRequest,
  PostScheduledMyMealProgramPreviewAdminRequest,
  ScheduledMyMealDailyOrderAdminRequest
} from '@/backend/market'
import type { ScheduledProgramFilters, ScheduledProgramRepository } from '../../domain/repositories/ScheduledProgramRepository'
import type { ScheduledProgramPreviewRequest } from '../../domain/repositories/ScheduledProgramRepository'

export class ScheduledProgramRepositoryImpl implements ScheduledProgramRepository {
  async getList(filters: ScheduledProgramFilters) {
    try {
      return await MealsService.getScheduledProgramsAdmin(filters)
    } catch {
      return { error: true as const }
    }
  }

  async get(id: string) {
    try {
      return await MealsService.getScheduledProgramAdmin({ id })
    } catch {
      return { error: true as const }
    }
  }

  async preview(request: ScheduledProgramPreviewRequest) {
    try {
      // The route and runtime payload are unchanged; this cast can be removed
      // once the refreshed Swagger artifact is committed to the panel.
      return await MealsService.postScheduledProgramPreviewAdmin({ requestBody: request as PostScheduledMyMealProgramPreviewAdminRequest })
    } catch {
      return { error: true as const }
    }
  }

  async create(request: PostScheduledMyMealProgramAdminRequest) {
    try {
      return await MealsService.postScheduledProgramAdmin({ requestBody: request })
    } catch {
      return { error: true as const }
    }
  }

  async update(id: string, request: ScheduledMyMealDailyOrderAdminRequest) {
    try {
      return await MealsService.putScheduledProgramAdmin({ id, requestBody: request })
    } catch {
      return { error: true as const }
    }
  }

  async cancel(id: string, request: PostCancelMealAdminRequest) {
    try {
      await MealsService.postScheduledProgramCancelAdmin({ id, requestBody: request })
      return { success: true as const }
    } catch {
      return { error: true as const }
    }
  }
}
